<div class="error-wrapper maintenance-bg" style="background-image: none; min-height: 100%; padding: 100px; background-color: white; border-radius: 15px;">
    <div class="container">
        <ul class="maintenance-icons">
            <li><i class="fa fa-cog"></i></li>
            <li><i class="fa fa-cog"></i></li>
            <li><i class="fa fa-cog"></i></li>
        </ul>
        <div class="maintenance-heading">
            <h2 class="headline" style="font-size: 50px; color: rgb(0, 166, 182); ">Access Denied</h2>
        </div>
        <h4 class="sub-content">
            You don't have access to view this page.
        </h4>
    </div>
</div>